import React from "react";
import { Link } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import MenuItem from "./menuitem";

const empresas = {
  gp: {
    nombre: "Portal GP",
  },
  millo: {
    nombre: "Propagas",
    logo: "logo-grupo-completo.png",
  },
  dblk: {
    nombre: "Doble K",
    logo: null,
  },
};

const getMenu = (tipo, menu, pages) => {
  if (!menu && pages && pages.length) {
    menu = [];

    pages
      .filter((page) => !!page.icon)
      .forEach((page) => {
        page.type.split(";").forEach((type) => {
          menu.push({
            type,
            page: page.name,
            label: page.title || page.name,
            icon: page.icon,
          });
        });
      });
  }

  return menu?.filter((opt) => opt.type === tipo);
};

const SideNav = ({ smMinH, smMarginT, menu, pages, empresa, tipo }) => {
  if (!empresa) empresa = "gp";

  menu = getMenu(tipo, menu, pages);

  return (
    <aside className="main-sidebar sidebar-md sidebar-light-primary elevation-2">
      <Link to="/" className="brand-link" style={smMinH}>
        {/* <img src={empresas[empresa].logo} alt="Logo" className="brand-image text-center float-center" style={{ maxHeight: "45px", float: "none" }} /> */}
        <span className="logo d-block text-center">{empresas[empresa].nombre}</span>
      </Link>
      <div className="sidebar p-0" style={smMarginT}>
        {menu ? (
          <nav className="mt-2">
            <ul className="nav nav-pills nav-sidebar flex-column">
              <MenuItem menu={menu} tipo={tipo} />
            </ul>
          </nav>
        ) : pages ? (
          <div className="mt-5 text-center ">
            <p>Sin opciones disponibles en este contexto.</p>
          </div>
        ) : (
          <div className="overlay mt-5 text-center ">
            <FontAwesomeIcon icon="sync-alt" size="2x" spin />
          </div>
        )}
      </div>
    </aside>
  );
};

export default SideNav;
